export default __webpack_public_path__ + "static/media/footer-back.14662dab.png";